<app-website-header></app-website-header>

<div class="containerr">
  <div
    style="background: #e1f1ff; width: 100%; padding: 0 20px 0 100px"
    class="welcomeHospitalContainer"
  >
    <div
      class="welcome p-0 g-0 py-2 py-md-5 row d-flex flex-column flex-xl-row align-items-lg-center justify-content-xl-between"
    >
      <div
        class="img col-12 col-xl-4 order-2 order-xl-1"
        style="max-width: 700px"
      >
        <img
          [src]="
            carouselImgs[currCarousel] ||
            '../../../../assets/images/EmptyHospiatalImage.svg'
          "
          alt=""
          class="d-flex d-lg-none img-fluid"
          style="height: 320px !important; border-radius: 20px"
        />
        <img
          [src]="
            carouselImgs[currCarousel] ||
            '../../../../assets/images/EmptyHospiatalImage.svg'
          "
          alt=""
          class="d-none d-lg-block col-12"
          height="700px"
          style="border-radius: 20px"
        />
        <div class="points">
          <div
            class="pointE"
            (click)="carouselChange(point)"
            *ngFor="let point of carouselImgs.slice(0, currCarousel)"
          ></div>
          <div class="point"></div>
          <div
            class="pointE"
            (click)="carouselChange(point)"
            *ngFor="let point of carouselImgs.slice(currCarousel + 1)"
          ></div>
        </div>
      </div>
      <div
        class="top-intro col-12 col-xl-6 w-100 w-xl-25 order-1 order-xl-2"
        style="flex: 1"
      >
        <p class="welcomee libra lh-sm">WELCOME TO</p>
        <p class="hospitalName d-md-none name2 libra fs-2 lh-sm">
          {{ hospitalData?.organization }}
        </p>
        <p class="hospitalName d-none d-md-block name2 libra">
          {{ hospitalData?.organization }}
        </p>
        <p class="estd libra fs-1 lh-base" *ngIf="hospitalData?.establishedIn">
          Established In: {{ hospitalData?.establishedIn | date }}
        </p>
      </div>
    </div>
  </div>

  <div class="portfolio">
    <div class="heading p-0 p-md-4">
      <span class="contact-heading heading-title libra">Our Portfolio</span>
    </div>
    <div
      class="serviceSliderContainer"
      *ngIf="servicesData && servicesData.length > 0; else noData"
    >
      <img
        class="d-none d-sm-block d-lg-block left-arrow"
        src="assets/images/specialities_left-arrow.svg"
        alt="Left Arrow"
        (click)="slide('left', 'bestServices-container')"
        [class.disabled]="!canSlideLeftServices"
        style="cursor: pointer; width: 40px; height: auto"
      />
      <div class="serviceImagesClinic bestServices-container">
        <ng-container>
          <div
            *ngFor="let data of servicesData; let i = index"
            class="static-image col-4 col-md col-lg"
          >
            <img [src]="data[1]" class="img-fluid d-block d-sm-none" alt="" />
            <img
              [src]="data[1]"
              class="d-none d-sm-block d-md-block d-lg-block"
              width="140px"
              height="100px"
              alt=""
            />
            <p>{{ data[0] }}</p>
          </div>
        </ng-container>
      </div>
      <img
        class="d-none d-sm-block d-lg-block right-arrow"
        src="assets/images/specialities_right-arrow.svg"
        alt="Right Arrow"
        (click)="slide('right', 'bestServices-container')"
        [class.disabled]="!canSlideRightServices"
        style="cursor: pointer; width: 40px; height: auto"
      />
    </div>
    <ng-template #noData>
      <p class="to-be-updated">To be updated soon</p>
    </ng-template>
    <div
      class="portfolioExternal"
      style="
        width: 100vw;
        display: flex;
        justify-content: center;
        padding: 20px 150px 20px 150px;
        background: #e1f1ff;
      "
    >
      <div
        class="b d-flex flex-column flex-xl-row p-0 p-lg-0 mt-3 mb-4 gap-3"
        style="display: flex; gap: 20px; justify-content: space-between"
      >
        <div class="r col-12 w-100">
          <img
            src="../../assets/images/hospital-portfolio.svg"
            alt=""
            class="img-fluid"
            width="100%"
            height="auto"
          />
        </div>
        <div class="l col-12">
          <div class="d-flex flex-column inner-services-m">
            <p class="tittle" style="font-weight: bold; font-size: 20px">
              A Passion For Putting Patients First
            </p>
            <div class="row gx-6 titles-column">
              <div class="col-6 my-2">
                <div class="d-flex align-items-center twenty twenty1">
                  <div class="point"></div>
                  <span> A Passion for Healing</span>
                </div>
              </div>
              <div class="col-6 my-2">
                <div class="d-flex align-items-center twenty twenty1">
                  <div class="point"></div>
                  <span> 5-star care</span>
                </div>
              </div>
              <div class="w-100"></div>
              <div class="col-6 my-2">
                <div class="d-flex align-items-center twenty twenty1">
                  <div class="point"></div>
                  <span> All Our Best</span>
                </div>
              </div>
              <div class="col-6 my-2">
                <div class="d-flex align-items-center twenty twenty1">
                  <div class="point"></div>
                  <span> Believe in Us</span>
                </div>
              </div>
              <div class="w-100"></div>
              <div class="col-6 my-2">
                <div class="d-flex align-items-center twenty twenty1">
                  <div class="point"></div>
                  <span> A Legacy of Excellence</span>
                </div>
              </div>
              <div class="col-6 my-2">
                <div class="d-flex align-items-center twenty twenty1">
                  <div class="point"></div>
                  <span> Always caring</span>
                </div>
              </div>
            </div>
            <p *ngIf="!about" class="to-be-updated" style="margin: auto">
              To Be Updated Soon
            </p>
            <p
              *ngIf="about"
              class="libra"
              style="text-align: justify"
              class="twenty"
              [innerHTML]="about"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="specialities d-flex align-items-center justify-content-center text-center"
  >
    <div
      class="equipmentsSpecialities specialities-data"
      *ngIf="specialitiesData?.length !== 0"
    >
      <div class="">
        <span class="contact-heading libra">Our Specialities</span>
      </div>
      <div
        class="contentSpecialities d-flex align-items-center"
        *ngIf="specialitiesData && specialitiesData.length > 0; else noData"
      >
        <img
          class="d-none d-lg-block custom-hide"
          src="assets/images/specialities_left-arrow.svg"
          alt="Left Arrow"
          (click)="slide('left', 'specialityContainer')"
          [class.disabled]="!canSlideLeftSpecialities"
          style="cursor: pointer"
        />

        <div
          class="imgs-container row-cols-2 row-lg d-flex d-lg-flex flex-lg-row overflow-hidden specialityContainer"
        >
          <ng-container>
            <div
              class="imgs-hospital speciality-items-lab"
              *ngFor="let speciality of specialitiesData"
              style="line-height: 30px !important"
            >
              <div class="icon-wrapper">
                <img
                  [src]="speciality[1]"
                  alt="equipments"
                  width="60px"
                  height="60px"
                />
              </div>
              <p class="infraName">
                {{ speciality[0] }}
              </p>
            </div>
          </ng-container>
        </div>
        <img
          class="d-none d-lg-block custom-hide"
          src="assets/images/specialities_right-arrow.svg"
          alt="Right Arrow"
          (click)="slide('right', 'specialityContainer')"
          [class.disabled]="!canSlideRightSpecialities"
          style="cursor: pointer"
        />
      </div>
      <ng-template #noData>
        <p class="to-be-updated">To be Updated soon</p>
      </ng-template>
    </div>
  </div>

  <div class="doctors" style="background-color: rgb(225, 241, 255)">
    <div class="heading p-0 p-md-4">
      <h2 class="libra" style="color: #484848">MEET OUR TEAM OF</h2>
      <span class="contact-heading headline header libra mb-3"
        >Healthcare Experts</span
      >
    </div>
    <div
      class="arrow-hosipital-container"
      *ngIf="hospitalData?.members?.length > 0; else noDoctors"
    >
      <img
        [ngClass]="{ disabled: !canSlideLeftDoctors }"
        class="d-none d-lg-block custom-hide"
        src="assets/images/specialities_left-arrow.svg"
        alt="Left Arrow"
        (click)="slide('left', 'hos-doc-container')"
        style="cursor: pointer"
      />
      <div class="cards row-cols-2 row-md">
        <div class="hos-doc-container" [ngClass]="containerClass">
          <div class="card col-4" *ngFor="let doctor of hospitalData?.members">
            <div class="image-wrapper">
              <img
                *ngIf="doctor?.image; else noImage"
                class="doctor-img d-none d-md-block"
                [src]="doctor?.image"
                alt="profile pic"
                width="120px"
                height="120px"
              />
              <ng-template #noImage>
                <div class="fallback-img">{{ getInitial(doctor?.name) }}</div>
              </ng-template>
            </div>
            <div class="info">
              <span
                class="name"
                style="text-align: center; word-break: break-spaces"
                ><span class="dr"></span
                ><span class="n fs-6 fs-4">{{ doctor?.name }}</span>
              </span>
              <p
                class="designation"
                style="text-align: center; word-break: break-spaces"
              >
                {{ doctor?.position?.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <img
        [ngClass]="{ disabled: !canSlideRightDoctors }"
        class="d-none d-lg-block custom-hide"
        src="assets/images/specialities_right-arrow.svg"
        alt="Left Arrow"
        (click)="slide('right', 'hos-doc-container')"
        style="cursor: pointer"
      />
    </div>
    <ng-template #noDoctors>
      <p class="to-be-updated">To be Updated soon</p>
    </ng-template>
  </div>

  <div
    class="equipmentsInfra infrastructure-equipments"
    *ngIf="infras?.length !== 0"
  >
    <div class="heading p-0 p-md-4">
      <h2 class="libra">WE PROVIDE CUTTING EDGE</h2>
      <span class="contact-heading libra">Infrastructure</span>
    </div>
    <div
      class="contentInfra row row-cols-2 row-md-12 align-items-start align-items-md-center justify-content-center justify-content-xl-around"
      style="padding-bottom: 1rem"
    >
      <div class="imgsInfra col-5 col-lg-4 equipment-img">
        <img
          src="../../assets/images/hospital-infrastructure.svg"
          alt="equipments"
          class="img-fluid d-block d-lg-none"
          height="auto"
        />
        <img
          src="../../assets/images/hospital-infrastructure.svg"
          alt="equipments"
          class="d-none d-lg-block"
          width="300px"
          height="auto"
        />
        <p class="infraNameInfra">
          Total Rooms:
          <span style="color: rgba(64, 64, 64, 1)">
            {{ infras?.totalRooms }}
          </span>
        </p>
      </div>
      <div class="imgsInfra col-5 col-lg-4 equipment-img">
        <img
          src="../../assets/images/icons/hospital-infra1.svg"
          alt="equipments"
          class="img-fluid d-block d-lg-none"
          height="auto"
        />
        <img
          src="../../assets/images/icons/hospital-infra1.svg"
          alt="equipments"
          class="d-none d-lg-block"
          width="300px"
          height="auto"
        />
        <p class="infraNameInfra">
          Total ICU Rooms:
          <span style="color: rgba(64, 64, 64, 1)">
            {{ infras?.totalIcuRooms }}
          </span>
        </p>
      </div>
      <div class="imgsInfra col-5 col-lg-4 equipment-img">
        <img
          src="../../assets/images/icons/hospital-infra2.svg"
          alt="equipments"
          class="img-fluid d-block d-lg-none"
          height="auto"
        />
        <img
          src="../../assets/images/icons/hospital-infra2.svg"
          alt="equipments"
          class="d-none d-lg-block"
          width="300px"
          height="auto"
        />
        <p class="infraNameInfra">
          Total Beds:
          <span style="color: rgba(64, 64, 64, 1)">
            {{ infras?.totalBeds }}
          </span>
        </p>
      </div>
      <div class="imgsInfra col-5 col-lg-4 equipment-img">
        <img
          src="../../assets/images/icons/hospital-infra3.svg"
          alt="equipments"
          class="img-fluid d-block d-lg-none"
          height="auto"
        />
        <img
          src="../../assets/images/icons/hospital-infra3.svg"
          alt="equipments"
          class="d-none d-lg-block"
          width="300px"
          height="auto"
        />
        <p class="infraNameInfra">
          Patient Capacity:
          <span style="color: rgba(64, 64, 64, 1)">
            {{ infras?.patientCapacity }}
          </span>
        </p>
      </div>
    </div>
  </div>
  <div
    class="equipments advanced-equipment"
    style="background-color: rgba(225, 241, 255, 1)"
  >
    <div class="heading p-0 p-md-4 text-center">
      <h2 class="mt-3 libra" style="color: #484848; padding-bottom: 5px">
        OUR ADVANCED
      </h2>
      <span class="contact-heading libra" style="margin-top: 0px"
        >Medical Equipments</span
      >
    </div>
    <div
      class="sliderContainer"
      *ngIf="equipmentsData.length > 0; else noEquipments"
    >
      <img
        class="d-none d-sm-block d-lg-block left-arrow"
        src="assets/images/specialities_left-arrow.svg"
        alt="Left Arrow"
        (click)="slide('left', 'ourAdvanced-container')"
        [class.disabled]="!canSlideLeftEquipments"
        style="cursor: pointer"
      />
      <div
        class="contentHospitalEquipments ourAdvanced-container"
        [class.scroll]="
          equipmentsData.length > 5 ||
          (isSmallScreen && equipmentsData.length > 0)
        "
      >
        <ng-container *ngFor="let equipment of equipmentsData">
          <div class="imgsHospitalEquipments advanced-equipment-imgs">
            <img
              [src]="equipment.imageUrl"
              alt="equipments"
              class="d-block d-md-none img-fluid imgMobile"
              style="object-fit: cover; width: 100%; max-height: 250px"
            />
            <img
              [src]="equipment.imageUrl"
              alt="equipments"
              class="d-none d-md-block"
              width="300px"
              height="250px"
            />
            <p class="infraName">{{ equipment.name }}</p>
          </div>
        </ng-container>
      </div>
      <img
        *ngIf="equipmentsData.length >= 5"
        class="d-none d-sm-block d-lg-block"
        src="assets/images/specialities_right-arrow.svg"
        alt="Right Arrow"
        (click)="slide('right', 'ourAdvanced-container')"
        [class.disabled]="!canSlideRightEquipments"
        style="cursor: pointer"
      />
    </div>
    <ng-template #noEquipments>
      <p class="to-be-updated">To be Updated soon</p>
    </ng-template>
  </div>

  <div class="achievements">
    <div class="heading p-0">
      <h2 class="libra achievments-title">ACHIEVEMENTS & CONTRIBUTIONS</h2>
      <p class="mt-2 mb-3 libra text-center">
        Honoring milestones, published works, and community efforts that define
        our commitment to healthcare excellence.
      </p>
    </div>
    <div class="hopspitalAchivements-scroll-container">
      <img
        class="d-none d-sm-block d-lg-block left-arrow"
        src="assets/images/specialities_left-arrow.svg"
        alt="Left Arrow"
        (click)="slide('left', 'contributions')"
        [class.disabled]="!canSlideLeftAcheivements"
        style="cursor: pointer; width: 40px; height: auto"
      />
      <div class="contributions">
        <div class="publications">
          <h2 class="contact-sub-headers p-0">Publications</h2>
          <ul #publicationsList class="scrollable-list">
            <ng-container
              *ngIf="publications && publications?.length !== 0; else elseBlock"
            >
              <li *ngFor="let publication of publications">
                <div
                  class="data d-flex flex-column flex-wrap flex-md-column align-items-md-start"
                >
                  <b> {{ publication?.title }}</b>
                  <span class="by"
                    >Published by :
                    <strong class="overflow-contributors-wrap">
                      {{ publication?.publishedby }}
                    </strong></span
                  >
                  <span class="by"
                    >Published Date :
                    <strong>
                      {{ publication?.publicationDate | date : "dd/MM/yyyy" }}
                    </strong></span
                  >
                </div>
              </li>
            </ng-container>
          </ul>
          <ng-template #elseBlock>
            <p class="to-be-updated" style ="margin: 50% 20px !important">To Be Updated Soon</p>
          </ng-template>
        </div>
        <div class="publications">
          <h2 class="contact-sub-headers">Awards & Honors</h2>
          <ul #awardsList class="scrollable-list">
            <ng-container
              *ngIf="awards && awards?.length !== 0; else elseBlock"
            >
              <li *ngFor="let award of awards">
                <div
                  class="data d-flex flex-column align-items-center flex-wrap flex-md-column align-items-md-start"
                >
                  <b>{{ award.title }}</b>
                  <span class="by"
                    >Awarded by:
                    <strong class="overflow-contributors-wrap"
                      >{{ award.association }}
                    </strong></span
                  >
                  <span
                    >Awarded Date :<strong
                      >{{ award.awardDate | date : "dd/MM/yyyy" }}
                    </strong>
                  </span>
                </div>
              </li>
            </ng-container>
          </ul>
          <ng-template #elseBlock>
            <p class="to-be-updated" style ="margin: 50% 20px !important">To Be Updated Soon</p>
          </ng-template>
        </div>
        <div class="publications">
          <h2 class="contact-sub-headers">Associations & Organizations</h2>
          <ul #associationsList class="scrollable-list">
            <ng-container
              *ngIf="associations && associations?.length !== 0; else elseBlock"
            >
              <li *ngFor="let association of associations">
                <div
                  class="data d-flex flex-column flex-wrap flex-md-column align-items-md-start"
                >
                  <b>{{ association.associationName }} </b>
                  <span class="by"
                    >Position:
                    <strong class="overflow-contributors-wrap">
                      {{ association.positionHeld }}
                    </strong>
                  </span>
                  <span class="by"
                    >From:
                    <strong>
                      {{ association.fromDate | date : "dd/MM/yyyy" }} to
                      {{ association.toDate | date : "dd/MM/yyyy" }}
                    </strong></span
                  >
                </div>
              </li>
            </ng-container>
          </ul>
          <ng-template #elseBlock>
            <p class="to-be-updated" style ="margin: 50% 20px !important">To Be Updated Soon</p>
          </ng-template>
        </div>
        <div class="publications">
          <h2 class="contact-sub-headers">Volunteering & Causes</h2>
          <ul #volunteeringsList class="scrollable-list">
            <ng-container
              *ngIf="
                volunteerings && volunteerings?.length !== 0;
                else elseBlock
              "
            >
              <li *ngFor="let volunteering of volunteerings">
                <div
                  class="data d-flex flex-column flex-wrap flex-md-column align-items-md-start"
                >
                  <b> {{ volunteering.organizationName }} </b>
                  <span class="by"
                    >Position:
                    <strong class="overflow-contributors-wrap">
                      {{ volunteering.positionHeld }}
                    </strong>
                  </span>
                  <span class="by"
                    >From:
                    <strong>
                      {{ volunteering.fromDate | date : "dd/MM/yyyy" }} to
                      {{ volunteering.toDate | date : "dd/MM/yyyy" }}
                    </strong></span
                  >
                </div>
              </li>
            </ng-container>
          </ul>
          <ng-template #elseBlock>
            <p class="to-be-updated" style ="margin: 50% 20px !important">To Be Updated Soon</p>
          </ng-template>
        </div>
        <div class="publications">
          <h2 class="contact-sub-headers p-0">Certifications</h2>
          <ul #certificationsList class="scrollable-list">
            <ng-container
              *ngIf="
                certifications && certifications?.length !== 0;
                else elseBlock"
            >
              <li *ngFor="let certification of certifications">
                <div
                  class="data d-flex flex-column flex-wrap flex-md-column align-items-md-start"
                >
                  <b>{{ certification.name }}</b>
                  <span class="by"
                    >Organization Name :
                    <strong class="overflow-contributors-wrap">
                      {{ certification.organizationName }}
                    </strong></span
                  >
                </div>
              </li>
            </ng-container>
          </ul>
          <ng-template #elseBlock>
            <p class="to-be-updated" style ="margin: 50% 20px !important">To Be Updated Soon</p>
          </ng-template>
        </div>
      </div>
      <img
        class="d-none d-sm-block d-lg-block"
        src="assets/images/specialities_right-arrow.svg"
        alt="Right Arrow"
        (click)="slide('right', 'contributions')"
        [class.disabled]="!canSlideRightAcheivements"
        style="cursor: pointer; width: 40px; height: auto"
      />
    </div>
  </div>

  <div class="lookat">
    <div class="outer-lookat">
      <div class="inner-lookat">
        <span class="lookat-heading libra">HAVE A LOOK AT</span>
        <span class="lookat-subtitle libra"
          >Our Facilities & Latest Activities
        </span>
      </div>
    </div>
    <div class="l">
      <div class="inner-l">
        <div
          class="small col-5 col-lg-auto m-1"
          *ngFor="let photo of photos"
          style="width: 260px; height: 280px"
        >
          <img
            [src]="photo?.photoLink"
            alt="small0"
            class="img-fluid d-block d-sm-none d-md-none"
            style="width: -webkit-fill-available"
          />
          <img
            [src]="photo?.photoLink"
            alt="small0"
            class="d-none d-sm-block d-md-none col-12"
            height="280px"
            width="260px"
          />
          <img
            [src]="photo?.photoLink"
            alt="small0"
            class="d-none d-sm-none d-md-block col-12"
            height="280px"
            width="260px"
          />
        </div>
      </div>
      <img
        src="../../assets/images/hospital-lookatr.svg"
        alt="r"
        class="d-none d-xl-block"
        width="320px"
        height="100%"
      />
    </div>
  </div>

  <div class="contact contact-items contianer-fluid">
    <span class="contact-heading libra p-3 p-md-5">Contact</span>
    <div
      class="inner d-flex flex-column flex-grow-1 d-xl-flex flex-xl-row flex-xl-grow-0"
    >
      <div class="l">
        <div class="emergency">
          <h2 class="contact-sub-headers libra">Emergency</h2>
          <span class="w-100">
            <img
              src="../../assets/images/icons/hospital-phone.svg"
              class="img-fluid"
              height="20px"
              alt=""
            />
            <p
              class="contact-information"
              style="cursor: pointer; text-decoration: none; color: #0d6efd"
              (click)="
                openDialPad(hospitalData?.phoneCode, hospitalData?.phone)
              "
            >
              {{ hospitalData?.phoneCode }} {{ hospitalData?.phone }}
            </p>
          </span>
        </div>
        <div class="emergency" style="max-width: 300px">
          <h2 class="contact-sub-headers libra">Location</h2>
          <span class="w-100">
            <img
              src="../../assets/images/icons/hospital-location.svg"
              class="img-fluid"
              height="20px"
              alt=""
            />
            <p class="contact-information">{{ hospitalData?.address }}</p>
          </span>
        </div>
        <div class="emergency">
          <h2 class="contact-sub-headers libra">Website</h2>
          <span class="w-100">
            <img
              src="../../assets/images/icons/hospital-website.svg"
              class="img-fluid"
              height="20px"
              alt=""
            />
            <p
              class="contact-information"
              style="cursor: pointer; text-decoration: none; color: #0d6efd"
              (click)="openWebsite(hospitalData?.url)"
            >
              {{ hospitalData?.url }}
            </p>
          </span>
        </div>
      </div>
      <div
        class="d-flex align-items-center justify-content-center qrCode flex-column flex-lg-row"
        #urlContainer
      >
        <div class="r d-block d-lg-none">
          <h2 class="contact-sub-headers libra">Social Media Links</h2>
          <div class="social-imgs" style="padding: 0; margin-bottom: 10px">
            <img
              (click)="socialNavigations('fb')"
              src="../../assets/images/icons/hospital-fb.svg"
              alt="fb"
            />
            <img
              (click)="socialNavigations('insta')"
              src="../../assets/images/icons/hospital-instagram.svg"
              class="insta"
              alt="insta"
            />
            <img
              (click)="socialNavigations('linkedin')"
              src="../../assets/images/icons/hospital-linkedin.svg"
              alt="linkedin"
            />
            <img
              (click)="socialNavigations('x')"
              src="../../assets/images/icons/twitter-icon1.svg"
              alt="x"
            />
          </div>
        </div>
        <img
          [src]="hospitalData?.qrCodeURL"
          alt="qr"
          width="180px"
          height="180px"
        />
      </div>
      <div class="r d-none d-lg-flex">
        <h2 class="contact-sub-headers libra">Social Media Links</h2>
        <div class="social-imgs">
          <img
            (click)="socialNavigations('fb')"
            src="../../assets/images/icons/hospital-fb.svg"
            alt="fb"
          />
          <img
            (click)="socialNavigations('insta')"
            src="../../assets/images/icons/hospital-instagram.svg"
            alt="insta"
          />
          <img
            (click)="socialNavigations('linkedin')"
            src="../../assets/images/icons/hospital-linkedin.svg"
            alt="linkedin"
          />
          <img
            (click)="socialNavigations('x')"
            src="../../assets/images/icons/twitter-icon1.svg"
            alt="x"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<app-website-footer></app-website-footer>
